import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "../component/Header.js/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { Link } from "react-router-dom";

const CancellationRefundPolicy = () => {
    const MainBox = styled.div`
    height: fit-content;
    padding: 4rem 4rem;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    @media only screen and (max-width: 1220px) {
      width: 100%;
      padding: 1rem;
    }
  `;

    return (
        <>
            <Navbar />
            <MainBox>
                <h2>Cancellation & Refund Policy</h2>
                <p>
                    At Samriddhi India, we work hard to keep every product listed on our website in stock and ready to ship. However, in the rare case that an item becomes unavailable, we will notify you within two (2) working days of your purchase via email.
                </p>
                <p>You will then have two options:</p>
                <ul>
                    <li>Substitute with a same or higher value product</li>
                    <li>Cancel the order and receive a full refund</li>
                </ul>
                
                <h3>Easy Online Cancellation</h3>
                <p>You can cancel your order before it has been shipped:</p>
                <ol>
                    <li>Login to your account on <a href="https://www.samriddhiindia.in" target="_blank" rel="noopener noreferrer">www.samriddhiindia.in</a></li>
                    <li>Go to the My Orders section</li>
                    <li>Place a cancellation request within 24 hours of placing the order (or before dispatch, whichever is earlier)</li>
                </ol>
                <p><strong>Full Refund:</strong> Your entire order amount will be refunded to your original payment source.</p>
                <p>
                    <strong>For Assistance:</strong> If you face any issue, email us at <a href="mailto:care@samriddhiindia.in">care@samriddhiindia.in</a> or call our number: +91 95207 82777.
                </p>
                
                <h3>Refund Policy</h3>
                <p>Refunds will be granted in the following cases:</p>
                <ul>
                    <li>Genuine quality issues with the product</li>
                    <li>Packages lost in transit</li>
                    <li>Incorrect item delivered</li>
                </ul>
                <p>Refunds will <strong>NOT</strong> be provided in these cases:</p>
                <ul>
                    <li>Slight design or color variations due to digital display differences</li>
                    <li>Products returned in a used, worn, damaged, or altered condition</li>
                </ul>
                <h4>Refund Timeline:</h4>
                <p>Refunds are processed within 10-15 working days after product verification at our warehouse.</p>
                <h4>Mode of Refund:</h4>
                <p>Refund will be credited to the same payment method used while placing the order.</p>
                
                <h3>Product Disclaimer</h3>
                <h4>Embroidery & Color</h4>
                <p>
                    Our products are handcrafted with care, but slight variations in embroidery or color may occur due to the natural characteristics of fabrics and lighting used during product photography.
                </p>
                <h4>Sizing</h4>
                <p>
                    Each garment’s fit depends on cut, style, and fabric. Please check the Size Guide available on the product page before placing your order. Slight measurement differences are normal due to fabric variations.
                </p>
                <h4>Color Display</h4>
                <p>
                    We make every effort to display product colors accurately on our website. However, there may be a slight difference in color due to monitor settings, screen brightness, and photographic lighting.
                </p>
                <h4>Wash Care</h4>
                <p>
                    Follow the wash care instructions mentioned on the product tag carefully to maintain product quality and longevity.
                </p>
                
                <h3>Exclusions from Exchange & Return</h3>
                <p>Products are only eligible for exchange/return if they are:</p>
                <ul>
                    <li>Unused, unwashed, unaltered</li>
                    <li>Returned with original tags intact</li>
                </ul>
                <p>Products with a “No Return” tag cannot be exchanged or returned.</p>
                
                <h3>Transactional Disputes</h3>
                <p>
                    Any disputes related to transactions will fall under the exclusive jurisdiction of the courts of Dehradun, India. Samriddhi India shall not be liable for any losses due to payment authorization decline caused by the cardholder's bank or payment gateway.
                </p>
                
                <h3>Right to Amend Policy</h3>
                <p>
                    Samriddhi India reserves the right to modify, amend, or update this Cancellation & Refund Policy at any time without prior notice.
                </p>
            </MainBox>
            <Footer />
        </>
    );
};

export default CancellationRefundPolicy;
